import { createFileRoute } from '@tanstack/react-router';
import { TenantFallback } from '@/features/system/TenantFallback';

export const Route = createFileRoute('/_public/tenant-fallback')({ component: TenantFallback });
